import { jsx as _jsx } from "react/jsx-runtime";
export const PmoIcon = ({ color })=>/*#__PURE__*/ _jsx("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 3.37903C1 2.93252 1.36196 2.57056 1.80847 2.57056H10.2397C10.6862 2.57056 11.0481 2.93252 11.0481 3.37903C11.0481 3.82553 10.6862 4.1875 10.2397 4.1875H1.80847C1.36196 4.1875 1 3.82553 1 3.37903ZM4.23353 8.99982C4.23353 8.55332 4.5955 8.19135 5.042 8.19135H13.4732C13.9197 8.19135 14.2817 8.55332 14.2817 8.99982C14.2817 9.44633 13.9197 9.80829 13.4732 9.80829H5.042C4.5955 9.80829 4.23353 9.44633 4.23353 8.99982ZM6.3898 14.6208C6.3898 14.1742 6.75176 13.8123 7.19827 13.8123H16.1915C16.638 13.8123 17 14.1742 17 14.6208C17 15.0673 16.638 15.4292 16.1915 15.4292H7.19827C6.75176 15.4292 6.3898 15.0673 6.3898 14.6208Z",
            fill: color || "#676879"
        })
    });
